export function paperReferenceName(metadata = {}, fallback = '') {
  if (metadata.short_reference) return metadata.short_reference;
  const names = (metadata.authors || [])
    .map((author) => author.family || author.literal || author.name)
    .filter(Boolean);
  if (!names.length) return metadata.title || fallback;
  const authors = names.length === 1 ? names[0]
    : names.length === 2 ? `${names[0]} & ${names[1]}`
      : `${names[0]} et al.`;
  return `${authors} (${metadata.year || 'n.d.'})`;
}
